(function () {
    'use strict';

    angular.module('app.userlogin', ['ngResource', 'ngMessages', 'ngSanitize']);

    angular
        .module('app.userlogin')
        .config(['$provide', errorHandler]);

    errorHandler.$inject = ['$provide'];

    function errorHandler($provide) {
        $provide.decorator("$exceptionHandler",
            ["$delegate",
                function ($delegate) {
                    return function (exception, cause) {
                        exception.message = "Please contact aSa. \n Message: " + exception.message;
                        $delegate(exception, cause);
                        alert(exception.message);
                    };
                }]);
    };


})();
